/*
 * @Desc:
 * @Author: zcc
 * @Date: 2022-11-03 17:09:53
 * @LastEditors: zcc
 * @LastEditTime: 2022-12-07 19:05:29
 */
import { createRouter, createWebHistory } from 'vue-router'
import Layout from '@/layouts'
const routes = [
  {
    path: '/',
    component: Layout,
    redirect: '/baas',
    children: [
      {
        path: '/baas',
        name: 'Baas',
        component: () => import('@/views/baas'),
        meta: {
          title: '首页'
        }
      },
      {
        path: '/mechanism-model',
        name: 'MechanismModel',
        component: () => import('@/views/mechanism-model'),
        meta: {
          title: '机理模型'
        }
      },
      {
        path: '/identity-resolution',
        name: 'IdentityResolution',
        component: () => import('@/views/identity-resolution'),
        meta: {
          title: '标识解析'
        }
      },
      {
        path: '/open-api',
        name: 'OpenAPI',
        component: () => import('@/views/open-api'),
        meta: {
          title: 'OpenAPI'
        }
      },
      {
        path: '/big-data',
        name: 'BigData',
        component: () => import('@/views/big-data'),
        meta: {
          title: '工业大数据'
        }
      },
      {
        path: '/blockchain',
        name: 'Blockchain',
        component: () => import('@/views/blockchain'),
        meta: {
          title: '区块链'
        }
      },
      {
        path: '/lcode',
        name: 'Lcode',
        component: () => import('@/views/lcode'),
        meta: {
          title: '低代码平台'
        }
      },
      {
        path: '/intelligent-vision',
        name: 'IntelligentVision',
        component: () => import('@/views/intelligent-vision'),
        meta: {
          title: '智能视觉'
        }
      },
      {
        path: '/bi',
        name: 'BI',
        component: () => import('@/views/bi'),
        meta: {
          title: 'BI平台'
        }
      }
    ]
  }

]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
